import { render, staticRenderFns } from "./DropdownTrigger.vue?vue&type=template&id=5a9c362e&"
import script from "./DropdownTrigger.vue?vue&type=script&lang=js&"
export * from "./DropdownTrigger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports